










import LoadingPrice from '@/components/molecules/item/price/kind/LoadingPrice.vue'
import { emptyState, PriceRange, PriceViewState } from '@/components/molecules/item/price/model/item-price-view'
import { getSingletonPaidMemberPriceLoaderForPath } from '@/components/molecules/item/price/model/paid-member-item-price-loader'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { PriceView, selectPriceView } from '../../model/select-price-view'

@Component
export default class ItemPriceWithPrimitiveValue extends Vue {
  @Prop({ required: true })
  readonly fkuId: string

  @Prop({ required: true })
  readonly priceExists: boolean

  @Prop({ required: true })
  readonly priceWithTax: string

  @Prop({ required: true })
  readonly priceWithoutTax: string

  @Prop({ required: true })
  readonly priceWithRange: boolean

  @Prop({ required: true })
  readonly brand: string

  @Prop({ default: null })
  readonly discountRate: string | null

  @Prop({ default: null })
  readonly discountAmount: string | null

  @Prop({ default: null })
  readonly discountUnit: string | null

  @Prop({ required: true })
  readonly skuIds: string

  priceView: PriceView = LoadingPrice
  state: PriceViewState = emptyState()

  get behavior(): BehaviorConfig {
    return BehaviorConfig.createFromBrand(this.brand)
  }

  get onlyShowPriceWithTax(): boolean {
    return this.behavior.item.price.onlyShowPriceWithTax
  }

  created() {
    const brand = this.brand
    const loader = getSingletonPaidMemberPriceLoaderForPath(brand, location.pathname)

    loader.getPriceForFku({ fkuId: this.fkuId, skuIds: this.skuIds.split(',') }).then((maybePaidMemberPrice) => {
      const nonPaidMemberPrice = {
        exists: this.priceExists,
        withTax: this.formattedPriceWithTax,
        withoutTax: this.formattedPriceWithoutTax,
        range: this.priceWithRange ? PriceRange.some() : PriceRange.none(),
      }

      this.state = maybePaidMemberPrice.foldL<PriceViewState>(
        () => {
          if (this.discountRate !== null) {
            return {
              isOnDiscount: true,
              nonPaidMemberPrice: {
                ...nonPaidMemberPrice,
                discountRate: this.discountRate,
                discountAmount: this.discountAmount ? this.discountAmount : '(￥ 0 OFF)',
                discountUnit: this.discountUnit ? this.discountUnit : 'percent',
              },
              paidMemberPrice: null,
            }
          }

          return {
            isOnDiscount: false,
            nonPaidMemberPrice,
            paidMemberPrice: null,
          }
        },
        paidMemberPrice => ({
          isOnDiscount: false,
          nonPaidMemberPrice,
          paidMemberPrice,
        })
      )

      this.priceView = selectPriceView(this.state, this.behavior)
    })
  }

  get _state(): PriceViewState {
    const basePrice = {
      exists: this.priceExists,
      withTax: this.priceWithTax,
      withoutTax: this.priceWithoutTax,
      range: this.priceWithRange ? PriceRange.some() : PriceRange.none(),
    }

    if (this.discountRate !== null) {
      return {
        isOnDiscount: true,
        nonPaidMemberPrice: {
          ...basePrice,
          discountRate: this.discountRate,
          discountAmount: this.discountAmount ? this.discountAmount : '(￥ 0 OFF)',
          discountUnit: this.discountUnit ? this.discountUnit : 'percent',
        },
        paidMemberPrice: null,
      }
    }

    return {
      isOnDiscount: false,
      nonPaidMemberPrice: basePrice,
      paidMemberPrice: null,
    }
  }

  private formatPrice(raw: string): string {
    const onlyDigits = raw.replace(',', '')
    const maybeNumber = parseInt(onlyDigits, 10)

    return isNaN(maybeNumber) ?
      '￥ -' :
      maybeNumber.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })
  }

  get formattedPriceWithTax(): string {
    return this.formatPrice(this.priceWithTax)
  }

  get formattedPriceWithoutTax(): string {
    return this.formatPrice(this.priceWithoutTax)
  }
}
